import React from "react";
import TextField from "../reusable/TextInput";
import { tw } from "@careinfo/tailwind";

const BrokerForm = (props: any) => {
  const { register, errors } = props;
  return (
    <>
      <div className={tw`grid grid-cols-1 gap-x-2 px-4`}>
        <TextField
          label="Name"
          register={register("name", {
            required: "Name is required",
          })}
          errors={errors?.name}
        />
      </div>
    </>
  );
};

export default BrokerForm;
